webpackJsonp([262374124431890],{

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Jump = factory());
	}(this, (function () { 'use strict';
	
	// Robert Penner's easeInOutQuad
	
	// find the rest of his easing functions here: http://robertpenner.com/easing/
	// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js
	
	var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
	  t /= d / 2;
	  if (t < 1) return c / 2 * t * t + b;
	  t--;
	  return -c / 2 * (t * (t - 2) - 1) + b;
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var jumper = function jumper() {
	  // private variable cache
	  // no variables are created during a jump, preventing memory leaks
	
	  var element = void 0; // element to scroll to                   (node)
	
	  var start = void 0; // where scroll starts                    (px)
	  var stop = void 0; // where scroll stops                     (px)
	
	  var offset = void 0; // adjustment from the stop position      (px)
	  var easing = void 0; // easing function                        (function)
	  var a11y = void 0; // accessibility support flag             (boolean)
	
	  var distance = void 0; // distance of scroll                     (px)
	  var duration = void 0; // scroll duration                        (ms)
	
	  var timeStart = void 0; // time scroll started                    (ms)
	  var timeElapsed = void 0; // time spent scrolling thus far          (ms)
	
	  var next = void 0; // next scroll position                   (px)
	
	  var callback = void 0; // to call when done scrolling            (function)
	
	  // scroll position helper
	
	  function location() {
	    return window.scrollY || window.pageYOffset;
	  }
	
	  // element offset helper
	
	  function top(element) {
	    return element.getBoundingClientRect().top + start;
	  }
	
	  // rAF loop helper
	
	  function loop(timeCurrent) {
	    // store time scroll started, if not started already
	    if (!timeStart) {
	      timeStart = timeCurrent;
	    }
	
	    // determine time spent scrolling so far
	    timeElapsed = timeCurrent - timeStart;
	
	    // calculate next scroll position
	    next = easing(timeElapsed, start, distance, duration);
	
	    // scroll to it
	    window.scrollTo(0, next);
	
	    // check progress
	    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
	    : done(); // scrolling is done
	  }
	
	  // scroll finished helper
	
	  function done() {
	    // account for rAF time rounding inaccuracies
	    window.scrollTo(0, start + distance);
	
	    // if scrolling to an element, and accessibility is enabled
	    if (element && a11y) {
	      // add tabindex indicating programmatic focus
	      element.setAttribute('tabindex', '-1');
	
	      // focus the element
	      element.focus();
	    }
	
	    // if it exists, fire the callback
	    if (typeof callback === 'function') {
	      callback();
	    }
	
	    // reset time for next jump
	    timeStart = false;
	  }
	
	  // API
	
	  function jump(target) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // resolve options, or use defaults
	    duration = options.duration || 1000;
	    offset = options.offset || 0;
	    callback = options.callback; // "undefined" is a suitable default, and won't be called
	    easing = options.easing || easeInOutQuad;
	    a11y = options.a11y || false;
	
	    // cache starting position
	    start = location();
	
	    // resolve target
	    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
	      // scroll from current position
	      case 'number':
	        element = undefined; // no element to scroll to
	        a11y = false; // make sure accessibility is off
	        stop = start + target;
	        break;
	
	      // scroll to element (node)
	      // bounding rect is relative to the viewport
	      case 'object':
	        element = target;
	        stop = top(element);
	        break;
	
	      // scroll to element (selector)
	      // bounding rect is relative to the viewport
	      case 'string':
	        element = document.querySelector(target);
	        stop = top(element);
	        break;
	    }
	
	    // resolve scroll distance, accounting for offset
	    distance = stop - start + offset;
	
	    // resolve duration
	    switch (_typeof(options.duration)) {
	      // number in ms
	      case 'number':
	        duration = options.duration;
	        break;
	
	      // function passed the distance of the scroll
	      case 'function':
	        duration = options.duration(distance);
	        break;
	    }
	
	    // start the loop
	    window.requestAnimationFrame(loop);
	  }
	
	  // expose only the jump method
	  return jump;
	};
	
	// export singleton
	
	var singleton = jumper();
	
	return singleton;
	
	})));


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	    module.exports['default'] = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  /* eslint-disable */
	  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
	  /* eslint-enable */
	
	  function replace (string, options) {
	    if (typeof string !== 'string') {
	      throw new Error('slugify: string argument expected')
	    }
	
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    var slug = string.split('')
	      .reduce(function (result, ch) {
	        return result + (charMap[ch] || ch)
	          // allowed
	          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	      }, '')
	      // trim leading/trailing spaces
	      .replace(/^\s+|\s+$/g, '')
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? slug.toLowerCase() : slug
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _categoryItem = __webpack_require__(249);
	
	var _categoryItem2 = _interopRequireDefault(_categoryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoriesList = function (_React$Component) {
	  _inherits(CategoriesList, _React$Component);
	
	  function CategoriesList() {
	    _classCallCheck(this, CategoriesList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoriesList.prototype.render = function render() {
	    var _props = this.props,
	        allData = _props.allData,
	        activeCategory = _props.activeCategory,
	        handleClick = _props.handleClick;
	
	    var sortedCategories = allData.sort(function (a, b) {
	      return a.node.orderNumber - b.node.orderNumber;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'categories-list' },
	      sortedCategories.map(function (cat, i) {
	        return _react2.default.createElement(_categoryItem2.default, {
	          key: i,
	          cat: cat,
	          handleClick: handleClick,
	          activeCategory: activeCategory });
	      })
	    );
	  };
	
	  return CategoriesList;
	}(_react2.default.Component);
	
	exports.default = CategoriesList;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _slugify = __webpack_require__(23);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryItem = function (_React$Component) {
	  _inherits(CategoryItem, _React$Component);
	
	  function CategoryItem() {
	    _classCallCheck(this, CategoryItem);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryItem.prototype.render = function render() {
	    var activeCategory = this.props.activeCategory;
	    var _props$cat$node = this.props.cat.node,
	        name = _props$cat$node.name,
	        description = _props$cat$node.description,
	        projects = _props$cat$node.projects;
	
	    var slug = (0, _slugify2.default)(name, { lower: true });
	    var categoryIsActive = activeCategory === slug;
	    var categoryIsActiveClass = ' ';
	    if (categoryIsActive) {
	      categoryIsActiveClass = 'active';
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'category-wrapper ' + categoryIsActiveClass },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { id: '' + slug, className: 'id-marker' }),
	        categoryIsActive && _react2.default.createElement(
	          'span',
	          { className: 'category-name-button' },
	          '-'
	        ),
	        !categoryIsActive && _react2.default.createElement(
	          'span',
	          { className: 'category-name-button' },
	          '+'
	        ),
	        _react2.default.createElement(
	          'span',
	          { onClick: this.handleClick.bind(this), className: 'category-name' },
	          name
	        ),
	        categoryIsActive && description && _react2.default.createElement('div', { className: 'category-description', dangerouslySetInnerHTML: {
	            __html: description.childMarkdownRemark.html
	          } }),
	        _react2.default.createElement(
	          'div',
	          { className: 'projects-list' },
	          projects.map(function (proj, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'project-wrapper' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'project-link', to: '/' + proj.slug },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'text' },
	                  _react2.default.createElement(
	                    'h4',
	                    null,
	                    proj.title
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    proj.shortDescription
	                  )
	                ),
	                _react2.default.createElement('img', { src: proj.imageThumbnail.file.url })
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  CategoryItem.prototype.handleClick = function handleClick() {
	    var handleClick = this.props.handleClick;
	    var name = this.props.cat.node.name;
	
	    var slug = (0, _slugify2.default)(name, { lower: true });
	
	    handleClick(slug);
	  };
	
	  return CategoryItem;
	}(_react2.default.Component);
	
	exports.default = CategoryItem;
	module.exports = exports['default'];

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var footerData = this.props.footerData;
	
	
	    return _react2.default.createElement(
	      'div',
	      { id: 'footer-wrapper', className: 'footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement('div', { className: 'markdown', dangerouslySetInnerHTML: {
	            __html: footerData.description.childMarkdownRemark.html
	          } }),
	        _react2.default.createElement('div', { className: 'markdown contact', dangerouslySetInnerHTML: {
	            __html: footerData.contactInformation.childMarkdownRemark.html
	          } })
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _mobileNavigation = __webpack_require__(83);
	
	var _mobileNavigation2 = _interopRequireDefault(_mobileNavigation);
	
	__webpack_require__(118);
	
	var _logo = __webpack_require__(141);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    var _props = this.props,
	        footerData = _props.footerData,
	        isNavActive = _props.isNavActive;
	
	    var mobileNavClass = isNavActive ? 'open' : 'closed';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'header' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { id: 'logo-area', className: 'logo', to: "/" },
	        _react2.default.createElement('img', { src: _logo2.default })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mobile-nav-wrapper' },
	        _react2.default.createElement(
	          'button',
	          { className: 'toggle-nav open', onClick: this.handleClick.bind(this) },
	          _react2.default.createElement(
	            'span',
	            null,
	            '+'
	          )
	        ),
	        _react2.default.createElement(_mobileNavigation2.default, {
	          linkData: this.props.linkData,
	          toggleMobileNav: this.handleClick.bind(this),
	          mobileNavClass: mobileNavClass, footerData: footerData })
	      )
	    );
	  };
	
	  Header.prototype.handleClick = function handleClick() {
	    this.props.setMobileState();
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navigation = __webpack_require__(26);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(24);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileNavigation = function (_React$Component) {
	  _inherits(MobileNavigation, _React$Component);
	
	  function MobileNavigation() {
	    _classCallCheck(this, MobileNavigation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MobileNavigation.prototype.render = function render() {
	    var _props = this.props,
	        mobileNavClass = _props.mobileNavClass,
	        footerData = _props.footerData;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'mobile-navigation ' + mobileNavClass },
	      _react2.default.createElement(
	        'button',
	        { className: 'toggle-nav close', onClick: this.handleClick.bind(this) },
	        _react2.default.createElement(
	          'span',
	          null,
	          ' - '
	        )
	      ),
	      _react2.default.createElement(_navigation2.default, { isMobile: true, linkData: this.props.linkData }),
	      _react2.default.createElement(_footer2.default, { footerData: footerData })
	    );
	  };
	
	  MobileNavigation.prototype.handleClick = function handleClick() {
	    var toggleMobileNav = this.props.toggleMobileNav;
	
	
	    toggleMobileNav();
	  };
	
	  return MobileNavigation;
	}(_react2.default.Component);
	
	exports.default = MobileNavigation;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(30);
	
	var _slugify = __webpack_require__(23);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_React$Component) {
	  _inherits(Navigation, _React$Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    var _props = this.props,
	        linkData = _props.linkData,
	        isMobile = _props.isMobile;
	
	    var sortedLinks = linkData.sort(function (a, b) {
	      return a.node.orderNumber - b.node.orderNumber;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'navigation' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navigation-wrapper' },
	        !isMobile && _react2.default.createElement(
	          'span',
	          { className: 'desktop index-link' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/categories' },
	            'Index'
	          )
	        ),
	        sortedLinks.map(function (cat, i) {
	          var name = (0, _slugify2.default)(cat.node.name, { lower: true });
	
	          return _react2.default.createElement(
	            'div',
	            { className: 'links', key: i },
	            _react2.default.createElement(
	              'span',
	              { className: 'mobile' },
	              _react2.default.createElement(
	                'a',
	                { href: '/' + name },
	                cat.node.name
	              )
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'desktop' },
	              _react2.default.createElement(
	                'a',
	                { href: '/categories#' + name },
	                cat.node.name
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: 'desktop' },
	          _react2.default.createElement(
	            'p',
	            { className: 'info-link', onClick: this.handleClick.bind(this) },
	            'INFO'
	          )
	        )
	      )
	    );
	  };
	
	  Navigation.prototype.handleClick = function handleClick() {
	    this.props.handleInfoClick();
	  };
	
	  return Navigation;
	}(_react2.default.Component);
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _categoriesList = __webpack_require__(248);
	
	var _categoriesList2 = _interopRequireDefault(_categoriesList);
	
	var _header = __webpack_require__(82);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(24);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(411);
	
	var _jump = __webpack_require__(117);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _slugify = __webpack_require__(23);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Categories = function (_React$Component) {
	  _inherits(Categories, _React$Component);
	
	  function Categories(props) {
	    _classCallCheck(this, Categories);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Categories.prototype.componentDidMount = function componentDidMount() {
	    var header = document.getElementsByClassName('header')[0];
	    header.classList += ' unfix';
	    var logo = document.getElementsByClassName('logo')[0];
	    logo.classList.remove('fade-down');
	
	    var hash = this.props.location.hash;
	
	    if (hash) {
	      setTimeout(function () {
	        (0, _jump2.default)('' + hash, {
	          duration: 600,
	          offset: -5
	        });
	      }, 300);
	    }
	
	    this.fadeInContent();
	  };
	
	  Categories.prototype.componentWillUnmount = function componentWillUnmount() {
	    var header = document.getElementsByClassName('header')[0];
	    header.classList.remove('unfix');
	    this.fadeOutContent();
	  };
	
	  Categories.prototype.render = function render() {
	    var activeCat = this.props.location.hash.split('#')[1];
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'main-wrapper categories' },
	      _react2.default.createElement(_categoriesList2.default, _extends({}, this.props, {
	        activeCategory: activeCat,
	        allData: this.props.data.allContentfulCategory.edges,
	        handleClick: this.handleClick.bind(this) })),
	      _react2.default.createElement(_footer2.default, { footerData: this.props.data.contentfulFooter })
	    );
	  };
	
	  Categories.prototype.fadeInContent = function fadeInContent() {
	    var wrapper = document.getElementById('content-wrapper');
	    setTimeout(function () {
	      wrapper.classList += ' visible';
	    }, 600);
	  };
	
	  Categories.prototype.fadeOutContent = function fadeOutContent() {
	    var wrapper = document.getElementById('content-wrapper');
	    if (wrapper.classList.contains('visible')) {
	      wrapper.classList.remove('visible');
	    }
	  };
	
	  Categories.prototype.handleClick = function handleClick(name) {
	    var history = this.props.history;
	
	    var slug = (0, _slugify2.default)(name, { lower: true });
	    var el = document.getElementById(slug);
	
	    if (history.location.hash === '#' + slug) {
	      history.replace('/categories');
	    } else {
	      history.push('#' + slug);
	      setTimeout(function () {
	        (0, _jump2.default)('#' + slug, {
	          duration: 600,
	          offset: -5
	        });
	      }, 300);
	    }
	  };
	
	  return Categories;
	}(_react2.default.Component);
	
	exports.default = Categories;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-categories-js-924032a2a7e25004264f.js